export const iconFontAwesomeArrowsChevronUp = (
	<i className="fa-solid fa-chevron-up"></i>
);
